<template>
  <view-wrap class="bg-light">
    <div id="changelog">
      <h1 class="h0 caps">Changelog</h1>
      <ul class="h4">
          <li>
          <h6>
              2020-02-24
          </h6>
          <ul>
               <li>
                   ❤️‍🔥 New tool alert: Injury alerts, get emails when a player with lots of minutes gets injured
               </li>
               <li>
                   ☝️ Tweaked Roster strength checkbox to be clearer
               </li>
          </ul>
        </li>
         <li>
          <h6>
              2020-02-10
          </h6>
          <ul>
               <li>
                   ❤️‍🔥 Added <a href="https://www.buymeacoffee.com/fantasyfalcon">Buy me a Coffee</a> widget
               </li>
          </ul>
        </li>
        <li>
          <h6>
              2020-01-31
          </h6>
          <ul>
               <li>
                   ☝️ Roster Strength: Ability to exclude injured players from stats
               </li>
               <li>
                   ☝️ Roster Strength: Stats for: 7 days / 14 days / season average
               </li>
               <li>
                   ☝️ Weekly performance / Category strengths: Checkbox added to show / hide ranks
               </li>
               <li>
                   Fixed regression: Auto-select last league / save 1 click on league selection
               </li>
               <li>
                   Fixed: Firefox won't ask you to re-login everytime you refresh the page
               </li>
          </ul>
        </li>
        <li>
          <h6>
              2020-01-24
          </h6>
          <ul>
               <li>
                   ❤️‍🔥 New tool alert - Roster Strength: Summing up all of your roster player averages this season, useful to compare how you would do against any of your matchups if you had the same number of games per player.
               </li>
               <li>
                   Table styling improvements
               </li>
               <li>
                   Hiding ranks temporarily to add a checkbox
               </li>
               <li>
                   Re-ordered 'Weekly Performance' to be the first tool since its the most used
               </li>
               <li>
                   '0.XX' FG% and FT% changed to '.XXX' to match Yahoo's fantasy sports style
               </li>
          </ul>
        </li>
        <li>
          <h6>
              2020-01-10
          </h6>
          <ul>
               <li>
                   Fixed general authentication bug
               </li>
               <li>
                   Added rank in 'Category strengths' and 'Weekly Performance' tables
               </li>
          </ul>
        </li>
        <li>
          <h6>
              2020-12-30
          </h6>
          <ul>
               <li>
                   Fixed Yahoo authentication bug
               </li>
               <li>
                   Fixed Compare Teams > Average difference +/- were reversed
               </li>
          </ul>
        </li>
        <li>
          <h6>
              2020-12-29
          </h6>
          <ul>
               <li>
                   Added this Changelog
               </li>
               <li>
                   Fixed mobile scrolling
               </li>
               <li>
                   Returning descending ordered list for leagues
               </li>
               <li>
                   Showing Wins-Losses-Ties instead of Wins-Ties-Losses (as per yahoo bball)
               </li>
          </ul>
        </li>
      </ul>
     
    </div>
  </view-wrap>
</template>

<script>

export default {
  name: "changelog",
  data () {
    return {}
  },
  components: {},
  methods: {}
};
</script>

<style src="./changelog.styl" lang="stylus" scoped></style>
